import React from "react";
import PropTypes from "prop-types";

import VehicleUnitIcon from "assets/icons/vehicle-unit.svg";
import MiniUnitIcon from "assets/icons/mini-storage-unit.svg";
import SmallUnitIcon from "assets/icons/small-storage-unit.svg";
import MediumUnitIcon from "assets/icons/medium-storage-unit.svg";
import LargeUnitIcon from "assets/icons/large-storage-unit.svg";
import LockerIcon from "assets/icons/locker.inline.svg";
import OutdoorIcon from "assets/icons/outdoor-space.inline.svg";
import WorkspaceIcon from "assets/icons/workspace.inline.svg";
import WineIcon from "assets/icons/wine.inline.svg";

const SIZE_CATEGORIES = [
	{ key: "mini", range: [0, 25] },
	{ key: "small", range: [26, 75] },
	{ key: "medium", range: [76, 200] },
	{ key: "large", range: [201, Infinity] }
];

const STORAGE_ICONS = {
	mini: MiniUnitIcon,
	small: SmallUnitIcon,
	medium: MediumUnitIcon,
	large: LargeUnitIcon
};

const SPECIAL_TYPE_ICONS = {
	parking_space: { icon: VehicleUnitIcon, alt: "Vehicle unit", isInline: false },
	locker: { icon: LockerIcon, alt: "Storage locker", isInline: true },
	outdoor: { icon: OutdoorIcon, alt: "Outdoor storage", isInline: true },
	workspace: { icon: WorkspaceIcon, alt: "Workspace", isInline: true },
	wine_storage: { icon: WineIcon, alt: "Wine storage", isInline: true }
};

const getSizeCategory = (squareFootage) => {
	if (!squareFootage) return "medium";
	const category = SIZE_CATEGORIES.find(
		(cat) =>
			squareFootage >= cat.range[0] &&
			squareFootage <= cat.range[1]
	);
	return category ? category.key : "large";
};

const UnitIcon = ({
	unitType,
	squareFootage,
	className
}) => {
	const specialType = SPECIAL_TYPE_ICONS[unitType];

	if (specialType) {
		const IconComponent = specialType.icon;
		return (
			<div className={className}>
				{specialType.isInline ? (
					<IconComponent aria-label={specialType.alt} />
				) : (
					<img src={IconComponent} alt={specialType.alt} />
				)}
			</div>
		);
	}

	// Default to storage unit icons based on size
	const sizeCategory = getSizeCategory(squareFootage);
	const iconSrc = STORAGE_ICONS[sizeCategory];
	const iconAlt = `${sizeCategory} storage unit`;

	// Check if unitType is vehicle/parking (alternate check)
	if (unitType === "vehicle") {
		return (
			<div className={className}>
				<img src={VehicleUnitIcon} alt="Vehicle unit" />
			</div>
		);
	}

	return (
		<div className={className}>
			<img src={iconSrc} alt={iconAlt} />
		</div>
	);
};

UnitIcon.propTypes = {
	unitType: PropTypes.oneOf([
		"storage",
		"parking_space",
		"locker",
		"outdoor",
		"workspace",
		"wine_storage",
		"vehicle"
	]),
	squareFootage: PropTypes.number,
	className: PropTypes.string
};

UnitIcon.defaultProps = {
	unitType: "storage",
	squareFootage: null,
	className: ""
};

export default UnitIcon;
